module.exports = __webpack_public_path__ + "img/householdequipment6.ba48e186.png";